// tslint:disable-next-line: no-default-export
export const registers = [
  {
    name: 'HandlePauseAudio',
    call: 'HandlePauseAudio',
    from: 'Android',
  },
  {
    name: 'HandleResumeAudio',
    call: 'HandleResumeAudio',
    from: 'Android',
  },
];
